// @flow

import _ from 'lodash';
import ko from 'knockout';

import type { Observable, PureComputed } from "rgs-knockout/types";


const unwrap = v => _.trim(ko.unwrap(v) || '');

export type FioInputArguments = {
	fullName: {
		attr: {
			placeholder: string,
		},
		jqInputcapitalize: string,
	},
	firstName: {
		value: Observable<string>,
		attr: {
			placeholder: string,
		},
		jqInputcapitalize: string,
	},
	lastName: {
		value: Observable<string>,
		attr: {
			placeholder: string,
		},
		jqInputcapitalize: string,
	},
	middleName: {
		value: Observable<string>,
		attr: {
			placeholder: string,
		},
		jqInputcapitalize: string,
	},
	disable: boolean | Observable<boolean> | PureComputed<boolean>,
}

export default class FioInput {
	_options: FioInputArguments;
	_lastName: Observable<string>;
	_firstName: Observable<string>;
	_middleName: Observable<string>;
	_fullName: PureComputed<string>;
	_mode: Observable<'full' | 'splited'>;
	_currentNamePart: Observable<null | 'last' | 'first' | 'middle'>;

	constructor (options: FioInputArguments) {
		this._options = _.defaultsDeep({}, options, {
			fullName: {
				attr: {
					placeholder: 'Введите ФИО',
				},
				jqInputcapitalize: 'titlecase',
			},
			firstName: {
				attr: {
					placeholder: '',
				},
				jqInputcapitalize: 'titlecase',
			},
			lastName: {
				attr: {
					placeholder: '',
				},
				jqInputcapitalize: 'titlecase',
			},
			middleName: {
				attr: {
					placeholder: '',
				},
				jqInputcapitalize: 'titlecase',
			},
			disable: false,
		});

		this._lastName = this._options.lastName.value;
		this._firstName = this._options.firstName.value;
		this._middleName = this._options.middleName.value;

		this._currentNamePart = ko.oneOf([
			null,
			'last',
			'first',
			'middle',
		]);

		this._mode = ko.oneOf([
			'full',
			'splited',
		]);

		this._fullName = ko.pureComputed({
			read: () => {
				const last = unwrap(this._lastName);
				const first = unwrap(this._firstName);
				const middle = unwrap(this._middleName);

				return `${last}${first ? (' ' + first) : ''}${middle ? (' ' + middle) : ''}`;
			},
			write: v => {
				const words = _.map(v.split(/\s+/g), _.trim);
				this._lastName(words[0]);
				this._firstName(words[1]);
				this._middleName(words.slice(2).join(' '));
			},
		});

		ko.computed(() => {
			this._middleName();

			ko.ignoreDependencies(() => {
				const middle = unwrap(this._middleName);
				const wordCount = (middle.match(/\s+/g) || []).length + 1;
				if (wordCount > 1) {
					this._mode('splited');
				}
			});
		});
	}

	_updateCurrentNamePart = (input: EventTarget) => {
		const value = input.value;
		const caret = input.selectionStart;
		const beforeCaret = value.slice(0, caret).replace(/\s+/g, ' ').replace(/^\s*/, '');
		const wordsBeforeCaret = beforeCaret.split(' ').length - 1;

		this._currentNamePart(['last', 'first'][wordsBeforeCaret] || 'middle');
	};

	_onFullNameBlur = (data: mixed, e: Event) => {
		e && e.preventDefault();

		this._currentNamePart(null);
	};

	_onFullNameAction = (data: mixed, e: Event) => {
		e && e.preventDefault();

		this._updateCurrentNamePart(e.target);
	}
}